<template>
  <v-app>
    <!-- <navigation-drawer/> -->
    <toolbar/>
    <v-content>
      <scale-transition group :duration="500" :delay="200">
        <router-view :key="$route.name"></router-view>
      </scale-transition>
    </v-content>
  </v-app>
</template>

<script>
import Toolbar from "@/components/common/Toolbar.vue";
// import NavigationDrawer from "@/components/labeling/NavigationDrawer.vue";
import {
  FadeTransition,
  SlideYDownTransition,
  CollapseTransition,
  ScaleTransition
} from "vue2-transitions";

export default {
  name: "App",
  data() {
    return {
      //
    };
  },
  components: {
    Toolbar, // , NavigationDrawer,
    FadeTransition,
    SlideYDownTransition,
    CollapseTransition,
    ScaleTransition
  }
};
</script>

<style>
.depressed {
  -webkit-box-shadow: 0 0px 0px #333;
  -moz-box-shadow: 0 0px 0px #333;
  box-shadow: 0 0px 0px #333;
}
.v-step {
  z-index: 999 !important;
  background-color: #719bee !important;
}
</style>
